/**
 * Whether the browser exposes the `webkitdirectory` attribute on `<input type="file">`.
 *
 * This is a presence check, and presence is all it can see. It covers iOS Safari, where WebKit gates
 * the IDL attribute to macOS so the property is genuinely absent — without the guard, "Folder upload"
 * there opens an ordinary file picker and the files upload flat into the current folder, which is
 * worse than not offering the action at all.
 *
 * Known gap: a browser that defines the property and then ignores it in the picker is invisible here.
 * Blink declares `webkitdirectory` unconditionally, so Chrome for Android passes this check and still
 * gets the flat-upload outcome. Closing that needs a different signal than feature detection and is
 * its own ticket, not a wider guard here.
 */
export function isDirectoryPickerSupported(): boolean {
  return typeof HTMLInputElement !== 'undefined' && 'webkitdirectory' in HTMLInputElement.prototype
}
